//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import {
  MediaFilterParamKey,
  NetworkType,
} from '@apis/content-library/contentLibraryApiModel';
import HR from '@components/atoms/hr/HR';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import {
  FilterSection,
  FilterSectionTitle,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';
import { getNetworkTypeLabel } from '@utils/networkTypeUtils';

export const DEFAULT_NETWORK_FILTER_SECTION: FilterSection<string> = {
  options: [
    {
      isSelected: false,
      value: NetworkType.INSTAGRAM,
      label: getNetworkTypeLabel(NetworkType.INSTAGRAM),
      trackingId: MediaLibraryTrackingIds.PLATFORM_INSTAGRAM_CHECKBOX,
    },
    {
      isSelected: false,
      value: NetworkType.FACEBOOK,
      label: getNetworkTypeLabel(NetworkType.FACEBOOK),
      trackingId: MediaLibraryTrackingIds.PLATFORM_FACEBOOK_CHECKBOX,
    },
    {
      isSelected: false,
      value: NetworkType.TIKTOK,
      label: getNetworkTypeLabel(NetworkType.TIKTOK),
      trackingId: MediaLibraryTrackingIds.PLATFORM_TIKTOK_CHECKBOX,
    },
    {
      isSelected: false,
      value: NetworkType.PINTEREST,
      label: getNetworkTypeLabel(NetworkType.PINTEREST),
      trackingId: MediaLibraryTrackingIds.PLATFORM_PINTEREST_CHECKBOX,
    },
    {
      isSelected: false,
      value: NetworkType.YOUTUBE,
      label: getNetworkTypeLabel(NetworkType.YOUTUBE),
      trackingId: MediaLibraryTrackingIds.PLATFORM_YOUTUBE_CHECKBOX,
    },
    {
      isSelected: false,
      value: NetworkType.TWITTER,
      label: getNetworkTypeLabel(NetworkType.TWITTER),
      trackingId: MediaLibraryTrackingIds.PLATFORM_TWITTER_CHECKBOX,
    },
    {
      isSelected: false,
      value: NetworkType.BAZAARVOICE,
      label: getNetworkTypeLabel(NetworkType.BAZAARVOICE),
      trackingId: MediaLibraryTrackingIds.PLATFORM_BAZAARVOICE_CHECKBOX,
    },
  ],
  paramKey: 'networks',
};

export interface NetworkFilterProps {
  isDisabled?: boolean;
  isInitiallyCollapsed?: boolean;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
  section: FilterSection<string> | undefined;
}

export const NetworkFilter = ({
  isDisabled,
  isInitiallyCollapsed,
  onChange,
  section = DEFAULT_NETWORK_FILTER_SECTION,
}: NetworkFilterProps) => {
  return (
    <>
      <CollapsibleSection
        isCollapsed={isInitiallyCollapsed}
        title={FilterSectionTitle[section.paramKey]}
      >
        <CheckboxSetFilter
          isDisabled={isDisabled}
          onChange={onChange}
          section={section}
        />
      </CollapsibleSection>
      <HR />
    </>
  );
};
